import { getAxiosInstance } from "@/axiosClient";

export async function fetchSummary() {
  return getAxiosInstance().get("/api/notifications/summary");
}

export async function fetchNotifications(page = 0, size = 5) {
  return getAxiosInstance().get("/api/notifications", {
    params: { page, size },
  });
}

export async function markAsRead() {
  return getAxiosInstance().put("/api/notifications/read");
}
